import { Route, Routes } from 'react-router-dom';
import { AppShell } from './AppShell';
import { RequireAuth, RequirePasswordChanged, RequirePermission } from './guards';
import { LoginPage } from '../pages/LoginPage';
import { RegisterPage } from '../pages/RegisterPage';
import { VerifyEmailPage } from '../pages/VerifyEmailPage';
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage';
import { ResetPasswordPage } from '../pages/ResetPasswordPage';
import { PasswordPage } from '../pages/PasswordPage';
import { ConsentPage } from '../pages/ConsentPage';
import { InvitePage } from '../pages/InvitePage';
import { OverviewPage } from '../pages/OverviewPage';
import { MembersPage } from '../pages/MembersPage';
import { OrgPage } from '../pages/OrgPage';
import { OrgVerificationPage } from '../pages/OrgVerificationPage';
import { RolesPage } from '../pages/RolesPage';
import { SecurityPage } from '../pages/SecurityPage';
import { SessionsPage } from '../pages/SessionsPage';
import { LoginHistoryPage } from '../pages/LoginHistoryPage';
import { ApplicationsPage } from '../pages/ApplicationsPage';
import { AuditPage } from '../pages/AuditPage';
import { FleetPage } from '../pages/FleetPage';
import { BillingPage } from '../pages/BillingPage';
import { SupportPage } from '../pages/SupportPage';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * 路由表。
 *
 * 三档边界很清楚：
 *   - 公开：登录、接受邀请；
 *   - 已登录但**不套外壳**：强制改密、OIDC 授权确认（页面本身就是完整一屏）；
 *   - 其余：登录 + 已改密 + 套控制台外壳。
 *
 * 权限判断只影响「能不能看到入口」；真正的拦截在 Worker 的 requirePermission。
 */
export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/invite" element={<InvitePage />} />

      <Route
        path="/password"
        element={
          <RequireAuth>
            <PasswordPage />
          </RequireAuth>
        }
      />
      <Route
        path="/consent"
        element={
          <RequireAuth>
            <ConsentPage />
          </RequireAuth>
        }
      />

      <Route
        path="*"
        element={
          <RequireAuth>
            <RequirePasswordChanged>
              <AppShell>
                <Routes>
                  <Route path="/" element={<OverviewPage />} />
                  <Route
                    path="/members"
                    element={
                      <RequirePermission permission="member.view">
                        <MembersPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="/org"
                    element={
                      <RequirePermission permission="org.view">
                        <OrgPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="/org/roles"
                    element={
                      <RequirePermission permission="role.view">
                        <RolesPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="/org/verification"
                    element={
                      <RequirePermission permission="org.view">
                        <OrgVerificationPage />
                      </RequirePermission>
                    }
                  />
                  <Route path="/security" element={<SecurityPage />} />
                  <Route path="/security/sessions" element={<SessionsPage />} />
                  <Route path="/security/history" element={<LoginHistoryPage />} />
                  <Route
                    path="/applications"
                    element={
                      <RequirePermission permission="app.view">
                        <ApplicationsPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="/audit"
                    element={
                      <RequirePermission permission="audit.view">
                        <AuditPage />
                      </RequirePermission>
                    }
                  />
                  <Route path="/fleet" element={<FleetPage />} />
                  <Route
                    path="/billing"
                    element={
                      <RequirePermission permission="billing.view">
                        <BillingPage />
                      </RequirePermission>
                    }
                  />
                  <Route path="/support" element={<SupportPage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </AppShell>
            </RequirePasswordChanged>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
